// extracted by mini-css-extract-plugin
module.exports = {"title":"UploadTdrForm_title_30H-L","fieldContainer":"UploadTdrForm_fieldContainer_3ogoo","spinAround":"UploadTdrForm_spinAround_332T7"};